exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ApSectorList.css */\n.expanded-list {\n  transition: height 0.3s ease;\n  height: 100%;\n}\n\n.collapsed-list {\n  transition: height 0.3s ease;\n  height: 50%;\n}\n\n.hidden {\n  display: none;\n}", ""]);

// exports
